import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Button, TextField } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";

import Dialog from "../Dialog";
import { closeAddSecProfile } from "../../reducers/DialogsReducer";
import {
  createSecProfile,
  findSecCode,
} from "../../pages/Security/SecFunction";
import { handleError } from "../../reducers/ErrorReducer";
import { notify } from "../../reducers/NotifierReducer";
import { gridStyle } from "../../utils/formStyles";
import Autocomplete2 from "../Autocomplete2";
import { notifyDataUpdate } from "../../reducers/DataUpdateReducer";

const AddSecProfileDialog = (props) => {
  const [name, setName] = useState("");
  const [currentType, setCurrentType] = useState(null);
  const [allTypes, setAllTypes] = useState([]);

  useEffect(() => {
    fetchTypes();
  }, []);

  const fetchTypes = async () => {
    const types = await findSecCode("profiletype");
    setAllTypes(types);
  };

  const close = () => {
    props.closeAddSecProfile();
  };

  const save = async () => {
    const data = {
      Label: name,
      Type: currentType?.Code || null,
    };
    try {
      const result = await createSecProfile(data);
      props.notifyDataUpdate({
        type: "add-profile",
        data: result.ptsProfileID,
      });
      props.notify("New Profile Created", "success");
      props.closeAddSecProfile();
    } catch (err) {
      props.handleError(err, "Error Creating New Profile");
    }
  };

  const renderActions = () => {
    return (
      <>
        <Button
          color="primary"
          variant="contained"
          autoFocus
          onClick={save}
          disabled={!name}
        >
          <SaveIcon /> Save
        </Button>
        <Button color="primary" onClick={close}>
          <CloseIcon /> Close
        </Button>
      </>
    );
  };

  const renderName = () => {
    return (
      <TextField
        label="Profile Name"
        variant="outlined"
        value={name}
        size="small"
        onChange={(e) => setName(e.target.value)}
        fullWidth
      />
    );
  };

  const renderType = () => {
    const handleChange = (e, newValue) => setCurrentType(newValue);
    return (
      <div className="mt-3">
        <Autocomplete2
          options={allTypes}
          sx={{ ...gridStyle(200, 800), margin: 0 }}
          onChange={handleChange}
          value={currentType}
          label="Profile Type"
          getOptionLabel={(option) => option.Code}
          isOptionEqualToValue={(option, value) => option.Code === value.Code}
          renderOption={(props, option) => (
            <li {...props}>
              {option.Code}{" "}
              {option.Description ? "- " + option.Description : ""}
            </li>
          )}
        />
      </div>
    );
  };

  return (
    <Dialog onClose={close} title="Add New Profile" actions={renderActions()}>
      <div>
        {renderName()}
        {renderType()}
      </div>
    </Dialog>
  );
};

export default connect(null, {
  closeAddSecProfile,
  notifyDataUpdate,
  handleError,
  notify,
})(AddSecProfileDialog);
